export default __webpack_public_path__ + "static/media/hht1_home_img_EP1.f41e3492.png";